import React from 'react';
import { frameworks } from '../data/mock';
import { 
  Workflow, 
  Award, 
  GitBranch, 
  RefreshCw, 
  ShieldCheck, 
  Sparkles 
} from 'lucide-react';

const iconMap = {
  'SAFe / Agile': Workflow,
  'Automotive SPICE': Award,
  'SDLC Best Practices': GitBranch,
  'CI/CD & DevOps': RefreshCw,
  'Secure Coding': ShieldCheck,
  'AI-Assisted SDLC': Sparkles
};

const Frameworks = () => {
  return (
    <section className="section-padding" id="frameworks" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="section-header">
          <p className="section-label">Frameworks & Standards</p>
          <h2 className="section-title">Industry-Proven Methodologies</h2>
          <p className="section-description">
            We operate on established frameworks and standards that OEMs and Tier-1 suppliers trust.
          </p>
        </div>
        
        <div className="frameworks-grid">
          {frameworks.map((framework) => {
            const IconComponent = iconMap[framework.name] || Workflow;
            return (
              <div key={framework.name} className="framework-card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[var(--accent-subtle)] rounded-lg flex items-center justify-center text-[var(--accent-primary)]">
                    <IconComponent size={20} />
                  </div>
                  <h3 className="framework-name" style={{ marginBottom: 0 }}>{framework.name}</h3>
                </div>
                <p className="framework-description">{framework.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Frameworks;
